import {
  Field,
  makeStyles,
  SpinButton,
  Switch,
  tokens,
} from '@fluentui/react-components';
import { useT } from '@powerportalspro/react';
import { NumberEdit, Section, SectionColumn } from '@powerportalspro/react-fluent';
import { useState } from 'react';

// Localization namespace — reuses the Blazor demo's
// `NumberEditPropertiesDemo` keys so both stacks read from the same JSON.
const STRINGS_BASE =
  'components.PowerPortalsPro.Demo.Client.Customizations.Pages.Editors.NumberEdit.NumberEditPropertiesDemo';

const useStyles = makeStyles({
  toolbar: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: tokens.spacingHorizontalL,
  },
  inlineField: {
    flexShrink: 0,
    gridTemplateColumns: 'auto auto',
    '& label': {
      whiteSpace: 'nowrap',
    },
  },
  numberInput: {
    width: '85px',
  },
});

export function NumberEditPropertiesSample() {
  const styles = useStyles();
  const t = useT();
  const [readOnly, setReadOnly] = useState(false);
  const [required, setRequired] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [min, setMin] = useState(0);
  const [max, setMax] = useState(100);
  const [precision, setPrecision] = useState(2);

  return (
    <Section>
      <SectionColumn
        header={
          <div className={styles.toolbar}>
            <Switch
              label={t(`${STRINGS_BASE}.readonly`)}
              labelPosition="before"
              checked={readOnly}
              onChange={(_, d) => setReadOnly(d.checked)}
            />
            <Switch
              label={t(`${STRINGS_BASE}.required`)}
              labelPosition="before"
              checked={required}
              onChange={(_, d) => setRequired(d.checked)}
            />
            <Switch
              label={t(`${STRINGS_BASE}.disabled`)}
              labelPosition="before"
              checked={disabled}
              onChange={(_, d) => setDisabled(d.checked)}
            />
            <Field
              label={t(`${STRINGS_BASE}.min`)}
              orientation="horizontal"
              className={styles.inlineField}
            >
              <SpinButton
                className={styles.numberInput}
                value={min}
                onChange={(_, d) => {
                  const n = typeof d.value === 'number' ? d.value : Number(d.displayValue);
                  if (Number.isFinite(n)) setMin(n);
                }}
              />
            </Field>
            <Field
              label={t(`${STRINGS_BASE}.max`)}
              orientation="horizontal"
              className={styles.inlineField}
            >
              <SpinButton
                className={styles.numberInput}
                value={max}
                onChange={(_, d) => {
                  const n = typeof d.value === 'number' ? d.value : Number(d.displayValue);
                  if (Number.isFinite(n)) setMax(n);
                }}
              />
            </Field>
            <Field
              label={t(`${STRINGS_BASE}.precision`)}
              orientation="horizontal"
              className={styles.inlineField}
            >
              <SpinButton
                className={styles.numberInput}
                min={0}
                max={10}
                value={precision}
                onChange={(_, d) => {
                  const n = typeof d.value === 'number' ? d.value : Number(d.displayValue);
                  if (Number.isFinite(n)) setPrecision(n);
                }}
              />
            </Field>
          </div>
        }
      >
        {/* Blazor demo binds to `ppp_percentcomplete`, a decimal column, so
            pin valueType to 'decimal'. NumberEdit's default ('int') would
            round-trip through the wrong ColumnValueBase subtype. */}
        <div style={{ maxWidth: '320px' }}>
          <NumberEdit
            columnName="ppp_percentcomplete"
            valueType="decimal"
            required={required}
            readOnly={readOnly}
            disabled={disabled}
            precision={precision}
            min={min}
            max={max}
          />
        </div>
      </SectionColumn>
    </Section>
  );
}
